// translations/faq.ts
export const translations = {
    en: {
      'faq.title': 'Frequently Asked',
      'faq.titleHighlight': 'Questions',
      'faq.items': [
        {
          question: 'What is EN 16931?',
          answer: 'EN 16931 is the European standard for electronic invoicing, required for public procurement across the EU.'
        },
        {
          question: 'Is EN 16931 mandatory?',
          answer: 'Yes, any business sending invoices to public authorities in the EU is required to comply with EN 16931.'
        },
        {
          question: 'Do I need technical skills?',
          answer: 'No. Our converter is designed to be user-friendly. Simply upload your PDF, and we\'ll handle the rest.'
        },
        {
          question: 'How long does conversion take?',
          answer: 'The conversion from PDF to EN 16931 XML is instantaneous. You can download your XML invoice within seconds.'
        },
        {
          question: 'How is my data protected?',
          answer: 'We use state-of-the-art encryption and security measures to protect your data. All uploads are processed securely and deleted after conversion.'
        },
        {
          question: 'Is my invoice information stored?',
          answer: 'No, we do not store any of your invoice information. Once the conversion is complete, all data is immediately and permanently deleted from our servers.'
        },
        {
          question: 'What happens if there\'s an error in conversion?',
          answer: 'Our AI is highly accurate, but in the rare case of an error, you can manually edit the output before finalizing. We also provide customer support to assist with any issues.'
        },
        {
          question: 'Can I use this for multiple invoices?',
          answer: 'Yes, our service is designed to handle both single and batch conversions. You can upload multiple PDF invoices and convert them to EN 16931 XML format efficiently.'
        },
        {
          question: 'What is the difference between XRechnung and EN 16931?',
          answer: 'EN 16931 is the European e-invoicing standard, while XRechnung is Germany\'s national implementation of this standard. XRechnung adds specific German requirements while maintaining compatibility with EN 16931.'
        },
        {
          question: 'Is XRechnung mandatory for all invoices to German authorities?',
          answer: 'Yes, since November 27, 2020, XRechnung is mandatory for all invoices to German federal authorities, with few exceptions (e.g., invoices under €1,000). Many state and local authorities also require XRechnung.'
        },
        {
          question: 'Can I send PDF invoices instead of XRechnung?',
          answer: 'No, PDF invoices are not accepted as e-invoices by German authorities. XRechnung requires structured XML data that can be processed automatically.'
        },
        {
          question: 'What formats are accepted for XRechnung?',
          answer: 'XRechnung accepts two XML syntax formats: Universal Business Language (UBL) and UN/CEFACT Cross Industry Invoice (CII). Both formats must comply with EN 16931 requirements.'
        },
        {
          question: 'How do I submit XRechnung invoices?',
          answer: 'XRechnung invoices can be submitted through various channels: the central platforms ZRE (for federal authorities) and OZG-RE (for state authorities), via PEPPOL network, or through approved service providers.'
        },
        {
          question: 'What information must be included in an XRechnung invoice?',
          answer: 'Besides standard invoice elements, XRechnung requires specific information like the buyer reference (Leitweg-ID), payment terms, bank details, and the invoice issuer\'s contact information.'
        },
        {
          question: 'Can I use ZUGFeRD instead of XRechnung?',
          answer: 'ZUGFeRD 2.1.1 or higher in XRECHNUNG profile is accepted by some authorities, but XRechnung is the preferred format. Check with your recipient which format they accept.'
        },
        {
          question: 'Do I need special software for XRechnung?',
          answer: 'Yes, you need software capable of creating XML files in the required format. Our converter helps you create valid XRechnung invoices from your existing PDF invoices.'
        },
        {
          question: 'Where can I find official information about XRechnung?',
          answer: 'You can find comprehensive information about XRechnung on the official government portals:<br><br><ul class="space-y-2"><li>• <a href="https://www.e-rechnung-bund.de/faq/xrechnung/" class="text-primary hover:underline" target="_blank" rel="noopener noreferrer">XRechnung FAQ Portal</a></li><li>• <a href="https://www.cio.bund.de/Webs/CIO/DE/digitale-loesungen/it-konsolidierung/dienstekonsolidierung/it-massnahmen/e-rechnungsportal/e-rechnung-node.html" class="text-primary hover:underline" target="_blank" rel="noopener noreferrer">Federal E-Invoicing Portal</a></li><li>• <a href="https://www.bmi.bund.de/DE/themen/moderne-verwaltung/verwaltungsmodernisierung/einfuehrung-e-rechnung/einfuehrung-e-rechnung-node.html" class="text-primary hover:underline" target="_blank" rel="noopener noreferrer">Federal Ministry of the Interior (BMI) Guidelines</a></li></ul>'
        },
        {
          question: 'When did XRechnung become mandatory?',
          answer: 'Since November 27, 2020, all suppliers to German federal agencies must submit invoices in XRechnung format. This requirement is part of the German government\'s digitalization initiative. For more details, visit the <a href="https://www.bmi.bund.de/DE/themen/moderne-verwaltung/verwaltungsmodernisierung/einfuehrung-e-rechnung/einfuehrung-e-rechnung-node.html" class="text-primary hover:underline" target="_blank" rel="noopener noreferrer">BMI website</a>.'
        }
      ],
    },
    de: {
      'faq.title': 'Häufig gestellte',
      'faq.titleHighlight': 'Fragen',
      'faq.items': [
        {
          question: 'Was ist EN 16931?',
          answer: 'EN 16931 ist der europäische Standard für elektronische Rechnungsstellung, der für die öffentliche Beschaffung in der EU erforderlich ist.'
        },
        {
          question: 'Ist EN 16931 verpflichtend?',
          answer: 'Ja, jedes Unternehmen, das Rechnungen an öffentliche Behörden in der EU sendet, muss EN 16931 einhalten.'
        },
        {
          question: 'Brauche ich technische Kenntnisse?',
          answer: 'Nein. Unser Konverter ist benutzerfreundlich gestaltet. Laden Sie einfach Ihre PDF hoch, und wir erledigen den Rest.'
        },
        {
          question: 'Wie lange dauert die Konvertierung?',
          answer: 'Die Konvertierung von PDF zu EN 16931 XML erfolgt sofort. Sie können Ihre XML-Rechnung innerhalb von Sekunden herunterladen.'
        },
        {
          question: 'Wie werden meine Daten geschützt?',
          answer: 'Wir verwenden modernste Verschlüsselungs- und Sicherheitsmaßnahmen zum Schutz Ihrer Daten. Alle Uploads werden sicher verarbeitet und nach der Konvertierung gelöscht.'
        },
        {
          question: 'Werden meine Rechnungsinformationen gespeichert?',
          answer: 'Nein, wir speichern keine Ihrer Rechnungsinformationen. Nach Abschluss der Konvertierung werden alle Daten sofort und dauerhaft von unseren Servern gelöscht.'
        },
        {
          question: 'Was passiert bei einem Konvertierungsfehler?',
          answer: 'Unsere KI ist sehr präzise, aber in den seltenen Fällen eines Fehlers können Sie die Ausgabe vor der Fertigstellung manuell bearbeiten. Wir bieten auch Kundenunterstützung bei allen Problemen.'
        },
        {
          question: 'Kann ich dies für mehrere Rechnungen verwenden?',
          answer: 'Ja, unser Service ist für Einzel- und Stapelkonvertierungen ausgelegt. Sie können mehrere PDF-Rechnungen hochladen und effizient in das EN 16931 XML-Format konvertieren.'
        },
        {
          question: 'Was ist der Unterschied zwischen XRechnung und EN 16931?',
          answer: 'EN 16931 ist der europäische Standard für elektronische Rechnungsstellung, während XRechnung die deutsche nationale Umsetzung dieses Standards ist. XRechnung fügt spezifische deutsche Anforderungen hinzu, behält aber die Kompatibilität mit EN 16931 bei.'
        },
        {
          question: 'Ist XRechnung für alle Rechnungen an deutsche Behörden verpflichtend?',
          answer: 'Ja, seit dem 27. November 2020 ist XRechnung für alle Rechnungen an Bundesbehörden verpflichtend, mit wenigen Ausnahmen (z.B. Rechnungen unter 1.000€). Viele Landes- und Kommunalbehörden verlangen ebenfalls XRechnung.'
        },
        {
          question: 'Kann ich stattdessen PDF-Rechnungen senden?',
          answer: 'Nein, PDF-Rechnungen werden von deutschen Behörden nicht als E-Rechnungen akzeptiert. XRechnung erfordert strukturierte XML-Daten, die automatisch verarbeitet werden können.'
        },
        {
          question: 'Welche Formate werden für XRechnung akzeptiert?',
          answer: 'XRechnung akzeptiert zwei XML-Syntaxformate: Universal Business Language (UBL) und UN/CEFACT Cross Industry Invoice (CII). Beide Formate müssen den EN 16931-Anforderungen entsprechen.'
        },
        {
          question: 'Wie reiche ich XRechnung-Rechnungen ein?',
          answer: 'XRechnung-Rechnungen können über verschiedene Kanäle eingereicht werden: die zentralen Plattformen ZRE (für Bundesbehörden) und OZG-RE (für Landesbehörden), über das PEPPOL-Netzwerk oder durch zugelassene Dienstleister.'
        },
        {
          question: 'Welche Informationen müssen in einer XRechnung enthalten sein?',
          answer: 'Neben den Standard-Rechnungselementen erfordert XRechnung spezifische Informationen wie die Käuferreferenz (Leitweg-ID), Zahlungsbedingungen, Bankverbindung und die Kontaktdaten des Rechnungsstellers.'
        },
        {
          question: 'Kann ich stattdessen ZUGFeRD verwenden?',
          answer: 'ZUGFeRD 2.1.1 oder höher im XRECHNUNG-Profil wird von einigen Behörden akzeptiert, aber XRechnung ist das bevorzugte Format. Prüfen Sie bei Ihrem Empfänger, welches Format akzeptiert wird.'
        },
        {
          question: 'Brauche ich spezielle Software für XRechnung?',
          answer: 'Ja, Sie benötigen Software, die XML-Dateien im erforderlichen Format erstellen kann. Unser Konverter hilft Ihnen dabei, gültige XRechnung-Rechnungen aus Ihren bestehenden PDF-Rechnungen zu erstellen.'
        },
        {
          question: 'Wo finde ich offizielle Informationen zur XRechnung?',
          answer: 'Sie finden umfassende Informationen zur XRechnung auf den offiziellen Regierungsportalen:<br><br><ul class="space-y-2"><li>• <a href="https://www.e-rechnung-bund.de/faq/xrechnung/" class="text-primary hover:underline" target="_blank" rel="noopener noreferrer">XRechnung FAQ-Portal</a></li><li>• <a href="https://www.cio.bund.de/Webs/CIO/DE/digitale-loesungen/it-konsolidierung/dienstekonsolidierung/it-massnahmen/e-rechnungsportal/e-rechnung-node.html" class="text-primary hover:underline" target="_blank" rel="noopener noreferrer">E-Rechnungsportal des Bundes</a></li><li>• <a href="https://www.bmi.bund.de/DE/themen/moderne-verwaltung/verwaltungsmodernisierung/einfuehrung-e-rechnung/einfuehrung-e-rechnung-node.html" class="text-primary hover:underline" target="_blank" rel="noopener noreferrer">Richtlinien des Bundesministeriums des Innern (BMI)</a></li></ul>'
        },
        {
          question: 'Seit wann ist XRechnung verpflichtend?',
          answer: 'Seit dem 27. November 2020 müssen alle Lieferanten an deutsche Bundesbehörden ihre Rechnungen im XRechnung-Format einreichen. Diese Anforderung ist Teil der Digitalisierungsinitiative der Bundesregierung. Weitere Details finden Sie auf der <a href="https://www.bmi.bund.de/DE/themen/moderne-verwaltung/verwaltungsmodernisierung/einfuehrung-e-rechnung/einfuehrung-e-rechnung-node.html" class="text-primary hover:underline" target="_blank" rel="noopener noreferrer">BMI-Website</a>.'
        }
      ],
    }
  };